<mat-sidenav-container class="shell" autosize>
  <mat-sidenav
    #sidenav
    class="shell-sidenav"
    mode="side"
    [opened]="opened()">
    <a routerLink="/" class="brand">
      <mat-icon>bolt</mat-icon>
      <span>Tesvolt POC</span>
    </a>

    <mat-divider></mat-divider>

    <mat-nav-list>
      @if (auth.isLoggedIn()) {
        <a mat-list-item routerLink="/document-types" routerLinkActive="active">
          <mat-icon matListItemIcon>description</mat-icon>
          <span matListItemTitle>Document types</span>
        </a>
        <a mat-list-item routerLink="/battery-models" routerLinkActive="active">
          <mat-icon matListItemIcon>battery_charging_full</mat-icon>
          <span matListItemTitle>Battery models</span>
        </a>
        <a mat-list-item routerLink="/batteries" routerLinkActive="active">
          <mat-icon matListItemIcon>battery_full</mat-icon>
          <span matListItemTitle>Batteries</span>
        </a>
      }
    </mat-nav-list>

    <span class="sidenav-spacer"></span>
    <mat-divider></mat-divider>

    @if (auth.isLoggedIn()) {
      <button mat-button class="user-button" [matMenuTriggerFor]="userMenu">
        <mat-icon>account_circle</mat-icon>
        <span class="user-name">{{ auth.displayName() }}</span>
        <mat-icon class="caret">arrow_drop_up</mat-icon>
      </button>
      <mat-menu #userMenu="matMenu" xPosition="after" yPosition="above">
        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span>Logout</span>
        </button>
      </mat-menu>
    } @else {
      <button mat-raised-button color="accent" class="login-button" (click)="login()">
        <mat-icon>login</mat-icon>
        Login
      </button>
    }
  </mat-sidenav>

  <mat-sidenav-content class="shell-content">
    <mat-toolbar color="primary" class="topbar">
      <button mat-icon-button (click)="toggle()" matTooltip="Toggle menu">
        <mat-icon>menu</mat-icon>
      </button>
      <span class="topbar-title">Tesvolt POC</span>
    </mat-toolbar>

    <main class="page">
      <router-outlet></router-outlet>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
